import { Box, Card, Typography } from "@mui/material";
import React from "react";
export function RedKidneyBeanCurry() {
  return (
    <Card sx={{ backgroundColor: "#bbbbbb" }}>
      <Typography variant="h1">Red Kidney Bean Curry</Typography>

      <Typography>
        <Typography variant="h3">Ingredients</Typography>
        250g dried red kidney beans <br></br>1 tbsp butter <br></br>2 tbsps oil{" "}
        <br></br>1 onion, chopped <br></br>
        cinnamon <br></br>2 dried bay leaves <br></br>3 garlic cloves <br></br>2
        tsps grated ginger <br></br>
        1/2 tsp tumeric <br></br>1 tsp ground coriander <br></br>2 tsps ground
        cumin <br></br>1 tsp garam masala <br></br>2 dried red chillies{" "}
        <br></br>4 tbsp tomato purée <br></br>
        salt and pepper <br></br>
        yoghurt to drizzle (optional)<br></br>
      </Typography>

      <Typography>
        Put the red kidney beans in a large saucepan, cover with cold water and
        let soak overnight. <br></br>
        Drain the soaked beans and return to the saucepan with double the amount
        of water. Bring to the boil, then keep boiling for 15 minutes. <br></br>
        <br></br>
        Reduce the heat to medium/low and simmer gently for 1 hour, or until the
        beans are tender. Drain, reserving the cooking liquid. <br></br>
        Heat the butter and oil in a large, heavy-based saucepan and add the
        onion, cinnamon, bay leaves, garlic, and ginger, and stri-fry for 4-5
        minutes.<br></br>
        Stir in the turmeric, ground coriander, garam masala, and chillies.{" "}
        <br></br>
        <br></br>
        Add the beans, tomato purée and enough of the reserved cooking liquid to
        make a thick sauce. Bring to the boil and cook for 4-5 minutes, stirring
        often. <br></br>
        Serve, with yoghurt if desired.<br></br>
      </Typography>
    </Card>
  );
}
